import React, { Fragment } from "react";
import Header2 from "../../components/header/Header2.jsx";
import Hero from "../../components/hero3/hero3.jsx";
import PartnerSection from "../../components/PartnerSection/index.jsx";
import About from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import WorkProcess from "../../components/WorkProcess/WorkProcess";
import IndustrieSection from "../../components/IndustrieSection/IndustrieSection";
import FeaturesSection from "../../components/FeaturesSection/FeaturesSection";
import Testimonial from "../../components/Testimonial/Testimonial";
import CtaSection from "../../components/CtaSection/CtaSection";
import FaqSection from "../../components/FaqSection/FaqSection";
import Footer from "../../components/footer/Footer";
import WhatsAppBtn from "../../components/WhatsAppBtn/WhatsAppBtn.jsx";

const HomePage = () => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <main className="page_content">
          <Hero />
          <PartnerSection />
          <About />
          <ServiceSection />
          <WorkProcess />
          <IndustrieSection />
          <Testimonial />
          <FeaturesSection />
          <FaqSection />
          <CtaSection />
        </main>
        <Footer />
        <WhatsAppBtn />
      </div>
    </Fragment>
  );
};
export default HomePage;